import moment from 'moment'
import { BACKEND_URL } from '../config'
import Model from './model'
import Hub from './hub'

const STATUS_COLOR = {
  ON_TIME: 'label-success',
  DELAYED: 'label-warning',
  VERY_DELAYED: 'label-danger'
}

class Step extends Model {
  static get name() {
    return 'steps'
  }

  static get url() {
    return `${BACKEND_URL}/infrastructure/transfers`
  }

  static get parsers() {
    return {
      ...Model.parsers,
      hub: dataDict => Hub.one(dataDict)
    }
  }

  get effectiveActualTime() {
    return this.actualTime || this.estimatedTime || this.scheduledTime
  }

  get delay() {
    if (this.isDone && !this.actualTime) return null
    const referenceTime = moment(
      this.actualTime || this.estimatedTime || this.scheduledTime
    )
    return moment.duration(referenceTime.diff(moment(this.scheduledTime)))
  }

  get delayHuman() {
    if (this.delay === null) return '-'
    const sign = this.delay.seconds() > 0 ? ' late' : ' early'
    const lateOrEarly = Math.abs(this.delay.asMinutes()) >= 1
    if (lateOrEarly) return '('.concat(this.delay.humanize(), sign, ')')
    return 'On time'
  }

  get delayInMinutes() {
    return this.delay.asMinutes()
  }

  get delayStatus() {
    if (this.delayInMinutes < 20) return 'ON_TIME'
    if (this.delayInMinutes < 40) return 'DELAYED'
    return 'VERY_DELAYED'
  }

  get delayLabel() {
    return STATUS_COLOR[this.delayStatus]
  }

  get isDelayed() {
    return this.delayInMinutes >= 20
  }

  get isVeryDelayed() {
    return this.delayInMinutes >= 40
  }

  load() {
    this.scheduledTime = this.scheduledTime && moment(this.scheduledTime)
    this.actualTime = this.actualTime && moment(this.actualTime)
    this.estimatedTime = this.estimatedTime && moment(this.estimatedTime)
  }
}

export default Step
